/** The exact CSV header row the backend expects, in order. */
export const BULK_INVITE_HEADERS = [
  'first_name',
  'last_name',
  'email',
  'phone_number',
  'role',
  'storage_quota',
  'api_quota',
] as const

export const BULK_INVITE_TEMPLATE_FILENAME = 'bulk-invite-template.csv'

/** Trigger a browser download of a CSV containing exactly the expected header row. */
export const downloadBulkInviteTemplate = (): void => {
  const csv = `${BULK_INVITE_HEADERS.join(',')}\n`
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = BULK_INVITE_TEMPLATE_FILENAME
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
